/*******************************************************************************

  Project: Amatin
  Author:  What.Digital
  Date:    10.2020

********************************************************************************

  1. Hamburger

*******************************************************************************/

(function ($) {
  /* 1. Hamburger
------------------------------------------------------------------------------*/

  $(".hamburger").on("click", function () {
    $("body").toggleClass("nav-act");
  }),
    $("header nav > ul > li.dropdown").on("click", function () {
      $("header nav li.dropdown").not(this).removeClass("act"),
        $(this).toggleClass("act");
    }),
    $(".links-list h3.color-alt").on("click", function () {
      $(".links-list h3.color-alt").not(this).removeClass("act"),
        $(this).toggleClass("act");
    });
})(jQuery); // end of $ code

jQuery(function ($) {
  var path = window.location.href;
  $("ul.filter a").each(function () {
    if (this.href === path) {
      $(this).parent().addClass("active");
      $("ul.filter li:first-child").removeClass("active");
    }
  });

  $(".search-wrap > i").click(function () {
    $(".search-wrap").addClass("act");
  });

  $(".search-wrap > span").click(function () {
    $(".search-wrap").removeClass("act");
  });
});

//# sourceMappingURL=main.js.map
